export default "__VITE_ASSET__aQGcs8by__"